__turbopack_context__.v({
  "input": "NumberInputField-module-scss-module__D90VNq__input",
});
